import React, { useEffect, useState } from "react";
import { Cookies } from '../../../../index.js';
import { alert_error, alert_success } from '../../../../AppContext';
import axios from 'axios';
import { Helmet } from "react-helmet";
const AboutUs = ({ datajoptiktok, base64Image_1, handleImageChange_1 }) => {
    const [show_example, setshow_example] = useState(false);
    return (
        <>
            <div className="mb-1">
                <h2 className="text-lg font-bold mb-0">Bước 1: Mở {datajoptiktok.social}</h2>
                <div className="text-center">
                    <a href={datajoptiktok.url_jop}
                        target="_blank" >Ấn vô link sau để mở {datajoptiktok.social}: {datajoptiktok.url_jop} </a>
                </div>
            </div>
            <div className="mb-1">
                <h2 className="text-lg font-bold mb-0">Bước 2: Reports</h2>
                <div className="text-center">
                    <li>Báo cáo bài viết hoặc video.</li>
                </div>
            </div>
            <div className="mb-1">
                <h2 className="text-lg font-bold mb-0">Bước 3: Xem ảnh mẫu</h2>
                <div className="text-center">
                    <div
                        className="button inline-block px-2 py-1 bg-blue-500 text-white font-semibold rounded-lg hover:bg-blue-600 transition duration-300"
                        onClick={() => setshow_example(!show_example)}
                    >
                        Xem hình ảnh mẫu ở đây
                    </div>
                    {show_example && (
                        <div className="flex text-center">
                            <div className="mx-auto" >
                                Ảnh tham gia: <img src='https://hust.media/link/load_image/fb_reports.PNG' alt="Selected" className=" w-36 rounded mr-4" />
                            </div>
                            {/* <div >
                                        Ảnh 2 link tham gia: <img src='https://hust.media/jop/google/zalo2.png' alt="Selected" className="w-28 rounded" />
                                    </div> */}
                        </div>
                    )}
                </div>
            </div>
            <div>
                <h2 className="text-lg font-bold mb-1">Bước 4: Gửi ảnh</h2>
                <ul className="list-disc pl-6">
                    <li>

                        {/* <div>
                                    Ảnh 1 tên nhóm:
                                    <input
                                        type="file"
                                        accept="image/*"
                                        onChange={handleImageChange}
                                        className="rounded"
                                    />
                                    {base64Image && (
                                        <div >
                                            <img src={base64Image} alt="Selected" className="w-44 rounded mr-4" />
                                        </div>
                                    )}
                                </div> */}
                        <div className="text-center">
                            Ảnh link reports:
                            <input
                                type="file"
                                accept="image/*"
                                onChange={handleImageChange_1}
                                className="rounded"
                            />
                            {base64Image_1 && (
                                <div className="">
                                    <img src={base64Image_1} alt="Selected" className="mx-auto w-44 rounded mr-4" />
                                </div>
                            )}
                        </div>

                    </li>

                    <li className="text-sm">Lưu ý: Chỉ làm trên điện thoại, ảnh cần hiển thị rõ đầy đủ username và yêu cầu reports</li>
                </ul>
            </div>
        </>
    );
}

export default AboutUs;
